import React, { Fragment } from "react";

import { Mobile, NotMobile } from "../../../../../hocs/Responsive";
import { DeviceActionsToggle } from "../../../../../components/devices/DeviceActionsDialog";
import { DeviceDropdownMenu } from "../../../../../components/devices/DeviceDropdownMenu";
import {
  EditRoamingDeviceDropdownItem,
  EditRoamingDeviceModalItem,
} from "../../../../../components/devices/editRoamingDeviceItem";
import {
  RevokeRoamingDeviceAccessDropdownItem,
  RevokeRoamingDeviceAccessModalItem,
} from "../../../../../components/devices/revokeRoamingDeviceAccessItem";

export const SingleRoamingDevicesDropdownActions = ({
  identifier,
  fullName,
  name,
}) => {
  const dropdownItems = [
    <EditRoamingDeviceDropdownItem identifier={identifier} />,
    <RevokeRoamingDeviceAccessDropdownItem identifier={identifier} />,
  ];

  const modalItems = [
    <EditRoamingDeviceModalItem identifier={identifier} />,
    <RevokeRoamingDeviceAccessModalItem identifier={identifier} />,
  ];

  return (
    <Fragment>
      <Mobile>
        <DeviceActionsToggle
          deviceName={fullName}
          menuItems={modalItems}
          ariaDeviceName={name}
        />
      </Mobile>
      <NotMobile>
        <DeviceDropdownMenu menuItems={dropdownItems} deviceName={name} />
      </NotMobile>
    </Fragment>
  );
};
